import * as permissionNames from 'common/constants/permissions';

const canManageSelfRegPortals = permissions => {
    return !!permissions[permissionNames.FBA_selfRegPortal] && !!permissions[permissionNames.orgAdmin];
};

export default {
    canManageSelfRegPortals
};
